import React from 'react';
import { ReactComponent as CloudsRainHome } from '../../images/clouds-rain-home.svg';

function ProductNotAvailable({
  sorry = "Sorry, we don't yet have any available offerings in this area.",
  clickHereMsg = ' to try a different State.',
  clickHereUrl = '/',
  clickHereLabel = 'Click here',
  clickHerePrefix = '',
}) {
  return (
    <div className="error-page" id="qa-product-not-available-page">
      <h1 className="headline">Product not available</h1>
      <div>
        <p>{sorry}</p>
        <p id="contact-link">
          {clickHerePrefix}
          <a href={clickHereUrl}>{clickHereLabel}</a>
          {clickHereMsg}
        </p>
      </div>
      <CloudsRainHome name="clouds-rain-home" className="clouds-rain-home-icon icon" />
    </div>
  );
}

export default ProductNotAvailable;
